import axios from '_u/axios'

// 项目规则列表
export const projRulesList = (body) => {
    return axios.post('proj/rules/list', body)
}

// 项目规则明细
export const projRulesView = (id) => {
    return axios.post('proj/rules/view', { id })
}

// 新增项目规则信息
export const projRulesAdd = (body) => {
    return axios.post('proj/rules/add', body)
}

// 修改项目规则信息
export const projRulesUpdate = (body) => {
    return axios.post('proj/rules/update', body)
}

// 删除项目规则信息
export const projRulesDelete = (id) => {
    return axios.post('proj/rules/delete', { id })
}